<template>
  <div class="page-view reset">
    <div class="container">
      <h1 class="page-title">Reset password</h1>
      <h3 class="subtitle" v-if="msg">
        {{ msg }}
      </h3>
      <div class="form-wrapper">
        <Form @submit="tryReset">
          <Field name="password" rules="req" type="password" placeholder="Nuova password"/>
          <ErrorMessage name="password" />
          <Field name="password2" rules="req|confirmed:@password" type="password" placeholder="Conferma password"/>
          <ErrorMessage name="password2" />
          <button type="submit" class="btn submit">
            Invia
          </button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute } from 'vue-router'
import { Field, Form, ErrorMessage } from 'vee-validate'

export default {
  components: {
    Field,
    Form,
    ErrorMessage
  },
  setup () {
    const query = useRoute().query
    return {
      query
    }
  },
  data () {
    return {
      msg: null
    }
  },
  methods: {
    async tryReset (values) {
      let msg = ''
      const reset = await this.$store.dispatch('resetPassword', {
        token: this.query.token,
        new_password: values.password
      })
      if (reset) {
        const error = false
        msg = 'PASSWORD resettata correttamente.'
        this.emitter.emit('fireAlert', { msg, error })
        setTimeout(() => {
          this.$router.push('/login')
        }, 2000)
      } else {
        const error = true
        msg = 'ERRORE durante il reset: ripetere la procedura.'
        this.emitter.emit('fireAlert', { msg, error })
      }
      this.msg = msg
    }
  },
  mounted () {
    // Use $route.query instead of the setup query
    const token = this.$route.query.token || this.query.token
    if (!token) {
      console.log('---No token found, redirecting to home')
      this.$router.push('/')
    } else {
      console.log('---Token found, staying on reset page')
    }
  }
}
</script>

<style scoped lang="scss">
  // @import "@/assets/scss/views/reset.scss";
  @import "@/assets/scss/forms.scss";

  .form-wrapper {
    @apply
      max-w-lg
      mt-4;
  }
</style>
